import { apiClient } from "../../../lib/api-client";
import { API_PATHS } from "../../../config/api";
import { Project } from "../../../types/project";

export const projectService = {
  getProjects: async (): Promise<Record<string, Project>> => {
    return apiClient.get(API_PATHS.GET_PROJECTS);
  },

  createProject: async (data: {
    name: string;
    description?: string;
    status?: "Public" | "Private";
  }): Promise<Project> => {
    return apiClient.post(API_PATHS.CREATE_PROJECT, data);
  },

  updateProject: async (data: Partial<Project>): Promise<Project> => {
    return apiClient.post(API_PATHS.UPDATE_PROJECT, data);
  },

  deleteProject: async (projectId: string | number): Promise<void> => {
    return apiClient.post(API_PATHS.DELETE_PROJECT, { id: projectId });
  },
};

export default projectService;
